module.exports = __webpack_public_path__ + "img/_6.f52332d9.png";